import { cssClass, textEllipsis } from '../../../style';

const cssPrefix = 'Breadcrumbs';

export namespace BreadcrumbStyles {
  export const Breadcrumb = cssClass(cssPrefix, 'breadcrumb', textEllipsis, {
    display: 'inline-block',
    maxWidth: '50ch',
    verticalAlign: 'bottom',
  });
}